import styled from "styled-components";
import { colorPrimary, colorSecondary, colorWhite, hex2rgba } from "../../colors";
import { BreakPoints, ContentWidths } from "../../constants";

export const StyledNavigation = styled.nav.attrs({
  className: "navigation__container",
})`

  font-family: Pitch Sans Medium;
  font-size: 0.75rem;
  display: flex;
  justify-content: center;
  position: sticky;
  top: 0;
  background-color: ${colorSecondary};
  color: ${colorWhite};
  width: 100%;
  box-sizing: border-box;
  max-height: 1000px;
  z-index: 10;

  .navigation {
    margin: 8px 15px;
    display: flex;
    flex-direction: column;

    @media (min-width: ${BreakPoints.sm}) {
      margin: 8px 0;
      width: ${ContentWidths.sm};
    }

    @media (min-width: ${BreakPoints.md}) {
      width: ${ContentWidths.md};
    }

    @media (min-width: ${BreakPoints.lg}) {
      width: ${ContentWidths.lg};
      flex-direction: column;
      margin: 0;
    }

    @media (min-width: ${BreakPoints.xl}) {
      width: ${ContentWidths.xl};
    }
  }

  &:has(.scroll-shrinked) {
    padding-top: 0;
    padding-bottom: 0;
  }

  button {
    background: none;
    padding: 0;
    color: inherit;
    border: none;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  .nav-bar {
    position: relative;
    z-index: 10;
    @media (min-width: ${BreakPoints.lg}) {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .nav-assets {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    height: 40px;
    z-index: 10;

    &__logo {
      height: 100%;
    }

    &__hamburger {
      border: 1px solid ${colorPrimary};
      padding: 4px 12px;
  
      @media (min-width: ${BreakPoints.lg}) {
        display: none;
      }
    }
  }
  
  .nav-links {
    display: flex;
    flex-direction: column;
    padding: 8px 0;
    margin: 0;
    visibility: visible;
    max-height: 1000px;
    overflow-y: hidden;
    transition: all 0.2s ease-in-out;

    @media (min-width: ${BreakPoints.lg}) {
      flex-direction: row;
      padding: 0;
    }

    &--transition-delay {
      transition-delay: 0.5s;
    }

    &--hidden {
      visibility: hidden;
      max-height: 0;
      padding: 0;
      transition: all 0.2s ease-in-out;

      @media (min-width: ${BreakPoints.lg}) {
        visibility: visible;
        max-height: 1000px;
      }
    }

    &__link {
      list-style-type: none;
      margin: 0;
      padding: 8px 0;
      transition: all .2s ease-in-out;

      @media (min-width: ${BreakPoints.lg}) {
        padding: 27px 12px;
      }

      @media (min-width: ${BreakPoints.xl}) {
        padding: 27px 16px;
      }

      &:hover,
      &:active {
        color: ${colorPrimary};
        padding-left: 24px;
        box-shadow: inset 4px 0 0 ${colorPrimary};
        transition: all .2s ease-in-out;

        @media (min-width: ${BreakPoints.lg}) {
          padding-left: 12px;
          box-shadow: inset 0 -4px 0 ${colorPrimary};
        }

        @media (min-width: ${BreakPoints.xl}) {
          padding-left: 16px;
        }
      }

      & a {
        color: inherit;
        text-decoration: none;
      }

      &--highlight {
        color: ${colorPrimary};
  
        @media (min-width: ${BreakPoints.lg}) {
          &:hover,
          &:active {
            box-shadow: none;
          }
        }
  
        & a {
          @media (min-width: ${BreakPoints.lg}) {
            padding: 6px 24px;
            box-shadow: inset 0 0 0 1px ${colorPrimary};
            transition: all .2s ease-in-out;
  
            &:hover,
            &:active {
              box-shadow: inset 0 0 0 4px ${colorPrimary};
              transition: all .2s ease-in-out;
            }
          }
        }
      }
    }

    &__dropdown {
      &:after {
        content: "";
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: 0.5em;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 6px solid ${hex2rgba(colorWhite, 0.3)};

        @media (min-width: ${BreakPoints.lg}) {
          display: block;
          margin: 2px auto -8px;
        }
      }
      &:hover,
      &:active {
        &:after {
          border-top-color: ${colorPrimary};
        }
      }
    }
  }

  .sports-links {
    display: flex;
    flex-direction: column;
    padding: 8px 0;
    margin: 0;

    @media (min-width: ${BreakPoints.sm}) {
      flex-direction: row;
      justify-content: space-between;
    }

    @media (min-width: ${BreakPoints.md}) {
      width: 540px;
      justify-content: flex-start;
    }

    @media (min-width: ${BreakPoints.lg}) {
      width: ${ContentWidths.lg};
    }

    @media (min-width: ${BreakPoints.xl}) {
      width: ${ContentWidths.xl};
    }
    
    &__container {
      box-sizing: border-box;
      z-index: 9;
      visibility: visible;
      max-height: 1000px;
      overflow-y: hidden;
      transition: all 0.2s ease-in-out;
      transition-delay: 0.2s;
      opacity: 1;

      @media (min-width: ${BreakPoints.lg}) {
        display: flex;
        justify-content: center;
        width: 100%;
        position: absolute;
        background-color: ${hex2rgba(colorSecondary, 0.95)};
        left: 0;
        top: 0;
        padding-top: 60px;
        padding-bottom: 12px;
      }

      &--hidden {
        visibility: hidden;
        max-height: 0;
        padding: 0;
        transition: all 0.2s ease-in-out;

        @media (min-width: ${BreakPoints.lg}) {
          opacity: 0;
        }
      }
    }

    &__link {
      list-style-type: none;
      margin: 0;
      padding: 8px 0;

      > * {
        margin-bottom: 0.5em;
      }

      & h5 {
        font-size: 0.75rem;
      }

      & a {
        color: inherit;
        text-decoration: none;
        color: ${colorPrimary};
        font-family: Pitch Sans Bold;
        text-transform: uppercase;
        letter-spacing: 0.2em;

        &:hover {
          text-decoration: underline;
        }

        &:after {
          content: "";
          display: inline-block;
          width: 0;
          height: 0;
          margin-left: 0.5em;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
          border-left: 6px solid ${colorPrimary};
        }
      }

      @media (min-width: ${BreakPoints.sm}) {
        flex-basis: 100%;

        &:nth-child(2) {
          margin: 0 16px;
        }
      }
    }

    &__description {
      color: ${hex2rgba(colorWhite, 0.6)};
    }
  }
`;
